module.exports = "<div class=\"auto-primary-header auto-page-header\">\r\n  <button mat-icon-button (click)=\"onOpenMenu($event)\">\r\n      <mat-icon \r\n      class=\"mat-icon material-icons\" \r\n      role=\"img\" \r\n      aria-hidden=\"true\">menu\r\n     </mat-icon>\r\n  </button>\r\n  <h1 focusonnavigation=\"\" tabindex=\"-1\">{{text}}</h1>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.html
// module id = ./src/app/header/header.component.html
// module chunks = main